import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { ApiError } from "go-core/api/types";
import { FormErrorMessageApi } from "go-form/components/FormErrorMessage";
import { CustomValidationConfig, CustomValidationConstraint, CustomValidationError } from "go-form/services/types";
import { PayOrderData } from "../../../../../../../services/Api/Public/types";

interface Props {
	form: UseFormReturn<PayOrderData>;
	setErrors: React.Dispatch<React.SetStateAction<CustomValidationError<PayOrderData>[]>>;
	setSendInvoice: React.Dispatch<React.SetStateAction<boolean>>;
	sendInvoice: boolean;
	customFormErrors: ApiError[];
}

const OrderPaymentInvoice = ({ form, setErrors, setSendInvoice, sendInvoice, customFormErrors }: Props) => {
	const {
		register,
		formState: { errors },
		watch,
	} = form;
	const validationConfig = useMemo(
		() => ({
			types: [{ constraint: CustomValidationConstraint.REQUIRED_IF, isRequired: () => sendInvoice }],
			setErrors,
			utils: { watch },
		}),
		[setErrors, watch, sendInvoice]
	) satisfies CustomValidationConfig;
	const { t } = useTranslation();

	return (
		<div className="mt-3 text-start order-send-invoice">
			<Form.Check
				label={t("modules.e_order.field.send_invoice.title")}
				checked={sendInvoice}
				onChange={() => setSendInvoice((prevState) => !prevState)}
				id="send-invoice"
				type="switch"
			/>
			{sendInvoice && (
				<>
					<FormInput
						name="tax_id_no"
						errors={errors}
						register={register}
						customValidationConfig={validationConfig}
						placeholder={t("lib:common.word.tax_id_no.title")}
						firstInput
						className="mt-3"
					/>
					{customFormErrors.length > 0 && <FormErrorMessageApi errors={customFormErrors} field="tax_id_no" />}
				</>
			)}
		</div>
	);
};

export default OrderPaymentInvoice;
